/* global SWING_TIMING_BINNED_DATA_LEAGUE, SWING_TIMING_DIMENSION_ORDER, serverParams */
import * as d3 from 'd3'

import SwingTimingChart, { type Dimension } from './swing-timing-chart.ts'

type VizSelection = d3.Selection<SVGSVGElement, unknown, HTMLElement, undefined>

type AxisInfo = {
    xAxisTitle: string
    yAxisTitle: string
}

type MetaDataEntry = {
    buckets: {
        maxBucket: number
        minBucket: number
    }
    centeredInterval: [number, number]
    axisInfo: AxisInfo
    bucketSize: number
}

type MetaData = Record<Dimension, MetaDataEntry>

const metaData: MetaData = {
    x: {
        buckets: {
            maxBucket: 15,
            minBucket: -12,
        },
        centeredInterval: [-4, 4],
        axisInfo: {
            // xAxisTitle: 'Tied Up / Flail',
            // yAxisTitle: 'Swings',
            xAxisTitle: '',
            yAxisTitle: '',
        },
        bucketSize: 2,
    },
    y: {
        buckets: {
            maxBucket: 30,
            minBucket: -30,
        },
        centeredInterval: [-7, 7],
        axisInfo: {
            // xAxisTitle: 'Late / Early',
            xAxisTitle: '',
            yAxisTitle: '',
        },
        bucketSize: 2,
    },
    z: {
        buckets: {
            maxBucket: 10,
            minBucket: -10,
        },
        centeredInterval: [-2, 2],
        axisInfo: {
            // xAxisTitle: 'Over / Under',
            xAxisTitle: '',
            yAxisTitle: '',
        },
        bucketSize: 1,
    },
}

window.charts = []

const yAxisTitle = 'Swing Percent'

function drawCharts(
    orderA: Dimension[],
    wrappers: VizSelection[]
): SwingTimingChart[] {
    // crude
    wrappers.forEach(($el) => {
        $el.html('')
    })

    // WHY GLOBAL?
    window.charts = orderA.map((dim, i) => {
        const { axisInfo } = metaData[dim]

        axisInfo.yAxisTitle = i === 0 ? yAxisTitle : ''
        const chart = new SwingTimingChart(
            wrappers[i],
            dim,
            i,
            SWING_TIMING_BINNED_DATA_LEAGUE,
            serverParams.secondarySplit
        )

        return chart
    })

    return window.charts
}

export default function initSwingTimingCharts() {
    const wrappers: VizSelection[] = [
        d3.select('#viz-container-primary svg'),
        d3.select('#viz-container-secondary-top svg'),
        d3.select('#viz-container-secondary-bottom svg'),
    ]

    const hasAllWrappers = wrappers.every(($el) => !$el.empty())

    if (!hasAllWrappers) {
        window.charts = []
        return window.charts
    }

    return drawCharts(SWING_TIMING_DIMENSION_ORDER, wrappers)
}
